import { createFileRoute } from '@tanstack/react-router';
import { TicketCheckInPanel } from '@/components/tickets/TicketCheckInPanel';

// Faculty ticket check-in — door staff at recitals are often instructors, and the
// ticket-checkin Edge Function allows faculty. Reissuing a lost QR stays admin-only,
// so this route is check-in only (no reissue panel).
export const Route = createFileRoute('/faculty/checkin')({
  component: FacultyCheckin,
});

function FacultyCheckin() {
  return (
    <div className="space-y-10">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Productions
        </p>
        <h1 className="mt-2">Ticket check-in</h1>
        <p className="mt-1 text-[var(--color-ink-muted)]">
          Scan or enter a ticket QR code to admit a guest. To reissue a lost ticket&rsquo;s code,
          ask an admin.
        </p>
      </header>
      <TicketCheckInPanel />
    </div>
  );
}
